const chMessages =  {
   "main.name": "姓名",
  "main.sentiment": "情绪",
  "main.urgency": "紧急程度",
  "main.language": "语言",
  "main.agent": "客服",
  "main.property_name": "物业名称",
  "main.booking_number": "预订编号",
  "main.check_out": "退房",
  "main.check_in": "入住",
  "main.adults": "成人",
  "main.corporate_code": "企业代码",
  "main.group_code": "团队代码",
  "main.promo_code": "优惠码",
  "main.ai_response": "AI 回复",
  "main.template_response": "模板回复",
  "main.converttoticket": "转换为工单",
  "main.switch_property": "切换物业",
  "main.Group_id": "组 ID",
  "main.integration_id": "集成 ID",
  "main.submit": "提交",
  "main.cancel": "取消",
    "main.select_template": "选择模板",
  "main.rooms": "客房",
  "main.rates": "价格",

  //footer
   "footer.knowledge": "知识",
  "footer.home": "主页",
  "footer.help": "帮助",

  //ticket
  "ticket.thank_you": "感谢您提交表单",
  "ticket.ticket": "工单",
  "ticket.details": "请填写描述工单详情的表单。",
  "ticket.select_category": "选择类别",
  "ticket.category": "类别",
  "ticket.title": "标题",
  "ticket.notes": "备注",
  "ticket.status": "状态",
  "ticket.assigned_to": "分配给",
  "ticket.submit_form": "提交表单",

  
  "main.total": "总计",
  "main.pastetooutlook": "粘贴到 Outlook",
  "main.children": "儿童",
  "main.promocode": "促销/企业/团体代码",
  "main.exact_match_only": "仅完全匹配",
  "main.search": "搜索",
  "main.no_rate_match": "没有符合您选择的价格。请修改搜索条件后重试。",
  "main.translate_to": "翻译为",
  "main.regenerate": "重新生成",
  "main.copy_text": "复制文本",
  "main.additional_instructions": "附加说明",

  "faq.helpcenter": "帮助中心",
  "faq.reply.email.sabre.question": "如何使用 Aven Hospitality Concierge Email Automation 回复邮件？",
  "faq.reply.email.sabre.answer": "打开邮件并启动 Aven Hospitality 插件。您可以选择三种方式：使用预定义模板、生成 AI 回复，或将邮件转换为工单。选择最适合咨询的选项，检查回复内容，必要时进行编辑，然后直接从 Outlook 发送。",

  "faq.rates.availability.question": "如何在回复中添加价格、可用性和房间详情？",
  "faq.rates.availability.answer": "使用 + Rates 功能输入日期和客人数等宾客信息，Concierge 会在回复中添加准确的可用性和价格。您还可以使用 + Rooms 添加房间描述和图片。",

  "faq.different.language.question": "如果邮件是其他语言，我应该怎么办？",
  "faq.different.language.answer": "Aven Hospitality Concierge 可以将收到的邮件翻译成您偏好的语言，使其更容易理解。",

  "faq.pin.addin.question": "如何确保插件始终在 Outlook 中可用？",
  "faq.pin.addin.answer": "在 Outlook 中固定 Aven Hospitality Concierge 插件，使其始终显示。",

  "faq.knowledge.hub.question": "什么是 Knowledge Hub 搜索选项？",
  "faq.knowledge.hub.answer": "Knowledge Hub 搜索可以帮助您在 Outlook 中快速查找酒店相关信息。",

  "faq.reply.email.myma.question": "如何使用 Myma 回复邮件？",
  "faq.reply.email.myma.answer": "打开邮件并启动 Myma 插件。您可以使用模板、生成 AI 回复或将邮件转换为工单。",

  "faq.room.details.question": "如何在回复中添加房间详情？",
  "faq.room.details.answer": "使用 + Rooms 添加房间描述和图片。",

  "faq.myma.different.language.question": "如果邮件是其他语言，我应该怎么办？",
  "faq.myma.different.language.answer": "Myma 可以将收到的邮件翻译成您偏好的语言。",

  "faq.myma.pin.addin.question": "如何确保插件始终在 Outlook 中可用？",
  "faq.myma.pin.addin.answer": "在 Outlook 中固定 Myma 插件，使其随每封邮件自动打开。",
};
export default chMessages;